var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.755,36.827c1.104,0,2-0.896,2-2v-9.723c0-1.104-0.896-2-2-2s-2,0.896-2,2v9.723 C34.755,35.932,35.651,36.827,36.755,36.827z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.806,23.104c-1.104,0-2,0.896-2,2v9.723c0,2.785-2.266,5.051-5.051,5.051s-5.051-2.266-5.051-5.051v-9.723 c0-1.104-0.896-2-2-2s-2,0.896-2,2v9.723c0,4.303,3.021,7.907,7.051,8.821v27.247c0,1.104,0.896,2,2,2s2-0.896,2-2V43.648 c4.03-0.914,7.051-4.518,7.051-8.821v-9.723C45.806,24,44.911,23.104,43.806,23.104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.296,23.104c-6.262,0-11.356,5.095-11.356,11.356v9.757c0,5.578,4.047,10.22,9.356,11.169v15.509c0,1.104,0.896,2,2,2 s2-0.896,2-2V25.104C68.296,24,67.4,23.104,66.296,23.104z M58.939,44.218v-9.757c0-3.362,2.27-6.199,5.356-7.073v23.903 C61.21,50.416,58.939,47.58,58.939,44.218z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.c9efe705b14b8f7aec7711acf6f20574.svg";
export { ForwardRef as ReactComponent };